import apiSportsEvent from '@/api/sports-events'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
}

export const mutationTypes = {
  getSportsEventAthletesListStart:
    '[sportsEvent athletes list] Get sportsEvents athletes start',
  getSportsEventAthletesListSuccess:
    '[sportsEvent athletes list] Get sportsEvents athletes success',
  getSportsEventAthletesListFailure:
    '[sportsEvent athletes list] Get sportsEvents athletes failure',
}

export const actionTypes = {
  getSportsEventAthletesList:
    '[sportsEvent athletes list] Get sportsEvent athletes list',
}

const mutations = {
  [mutationTypes.getSportsEventAthletesListStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getSportsEventAthletesListSuccess](state, payload) {
    state.total = payload.total
    state.data = payload.data ? payload.data : payload.list
    state.isLoading = false
  },

  [mutationTypes.getSportsEventAthletesListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getSportsEventAthletesList](context, params) {
    context.commit(mutationTypes.getSportsEventAthletesListStart)
    return new Promise((resolve) => {
      apiSportsEvent
        .getSportsEventsAthletesList(params)
        .then((response) => {
          context.commit(mutationTypes.getSportsEventAthletesListSuccess, {
            ...response.data,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getSportsEventAthletesListFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
